<div class="container">
    <h3>APPOINTMENT ID: {{app_Id}}</h3>
</div>

<div class="container">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <h4>Appointment Details :</h4>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <h4>Payment Details :</h4>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <table class="table">
                <tbody>
                    <tr>
                        <td>Appointment Date</td>
                        <td>:</td>
                        <td>{{getInfo?.AppoitmentDetails?.appointmentTime|date:'dd/MM/yy, h:mm a'}}</td>
                    </tr>
                    <tr>
                        <td>Booked By</td>
                        <td>:</td>
                        <td>{{getInfo?.AppoitmentDetails?.BookedBy|titlecase}}</td>
                    </tr>
                    <tr>
                        <td>Doctor</td>
                        <td>:</td>
                        <td>{{getInfo?.AppoitmentDetails?.consultDoctor|titlecase}}</td>
                    </tr>
                    <tr>
                        <td>Mode of Consultation</td>
                        <td>:</td>
                        <td>{{getInfo?.AppoitmentDetails?.modeOfConsultaion}}</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>:</td>
                        <td>{{getInfo?.AppoitmentDetails?.status}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <table class="table">
                <tbody>
                    <tr>
                        <td>Payment ID</td>
                        <td>:</td>
                        <td>{{getInfo?.PaymentDetails?.paymentId}}</td>
                    </tr>
                    <tr>
                        <td>Order ID</td>
                        <td>:</td>
                        <td>{{getInfo?.PaymentDetails?.orderId}}</td>
                    </tr>
                    <tr>
                        <td>Amount Paid</td>
                        <td>:</td>
                        <td>{{ getInfo?.PaymentDetails?.AmountPaid/100 |currency:'INR'}}</td>
                    </tr>
                    <tr>
                        <td>Payment Status</td>
                        <td>:</td>
                        <td>{{getInfo?.PaymentDetails?.paymentStatus}}</td>
                    </tr>
                    <tr>
                        <td>Transaction Time</td>
                        <td>:</td>
                        <td>{{getInfo?.PaymentDetails?.trasactionStartTime|date:'dd/MM/yy, h:mm a'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h4>Patient Details :</h4>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <table class="table">
                <tbody>
                    <tr>
                        <td>Name</td>
                        <td>:</td>
                        <td>{{getInfo?.PatientDetails?.patientName|titlecase}}</td>
                    </tr>
                    <tr>
                        <td>Age</td>
                        <td>:</td>
                        <td>{{getInfo?.PatientDetails?.patientAge}}</td>
                    </tr>
                    <tr>
                        <td>Gender</td>
                        <td>:</td>
                        <td>{{getInfo?.PatientDetails?.patientGender}}</td>
                    </tr>
                    <tr>
                        <td>Relationship</td>
                        <td>:</td>
                        <td>{{getInfo?.PatientDetails?.patientRelation}}</td>
                    </tr>
                    <tr>
                        <td>Phone Number</td>
                        <td>:</td>
                        <td>{{getInfo?.PatientDetails?.patientMobileNo}}</td>
                    </tr>
                    <tr>
                        <td>Email ID</td>
                        <td>:</td>
                        <td>{{getInfo?.PatientDetails?.patientMail|titlecase}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 right-column">
            <p>Reports :</p>
            <div *ngIf="getInfo?.AppoitmentDetails?.files.length">
                <ng-container *ngFor="let file of getInfo?.AppoitmentDetails?.files ;let i =index">
                    <a style="cursor: pointer;" (click)="getFileId(file)">{{file.fileName}}</a>{{i ===
                    getInfo?.AppoitmentDetails?.files.length-1 ? '' : ',&nbsp;'}}
                </ng-container>
                <!-- <span class="glyphicon glyphicon-picture"></span>
                <span class="glyphicon glyphicon-picture"></span>
                <span class="glyphicon glyphicon-picture"></span> -->
            </div>
            <p>Additional Notes :</p>
            <span>{{getInfo?.AppoitmentDetails?.aditionalInfo}}</span>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <h4>Doctor Details :</h4>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <h4>Member Details :</h4>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <table class="table">
                <tbody>
                    <tr>
                        <td>ID</td>
                        <td>:</td>
                        <td>{{getInfo?.doctorDetails?.doctorId}}</td>
                    </tr>
                    <tr>
                        <td>Name</td>
                        <td>:</td>
                        <td>{{getInfo?.doctorDetails?.doctorName|titlecase}}</td>
                    </tr>
                    <tr>
                        <td>Age</td>
                        <td>:</td>
                        <td>{{getInfo?.doctorDetails?.dcotorAge}}</td>
                    </tr>
                    <tr>
                        <td>Gender</td>
                        <td>:</td>
                        <td>{{getInfo?.doctorDetails?.doctorGender}}</td>
                    </tr>
                    <tr>
                        <td>Phone Number</td>
                        <td>:</td>
                        <td>{{getInfo?.doctorDetails?.doctorMobileNo}}</td>
                    </tr>
                    <tr>
                        <td>Email ID</td>
                        <td>:</td>
                        <td>{{getInfo?.doctorDetails?.doctorMail|titlecase}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <table class="table">
                    <tbody>
                        <tr>
                            <td>ID</td>
                            <td>:</td>
                            <td>{{getInfo?.memberDetails?.memberId}}</td>
                        </tr>
                        <tr>
                            <td>Name</td>
                            <td>:</td>
                            <td>{{getInfo?.memberDetails?.memberName|titlecase}}</td>
                        </tr>
                        <tr>
                            <td>Age</td>
                            <td>:</td>
                            <td>{{getInfo?.memberDetails?.memberAge}}</td>
                        </tr>
                        <tr>
                            <td>Gender</td>
                            <td>:</td>
                            <td>{{getInfo?.memberDetails?.memberGender}}</td>
                        </tr>
                        <tr>
                            <td>Phone Number</td>
                            <td>:</td>
                            <td>{{getInfo?.memberDetails?.memberMobileNo}}</td>
                        </tr>
                        <tr>
                            <td>Email ID</td>
                            <td>:</td>
                            <td>{{getInfo?.memberDetails?.memberEmail|titlecase}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- *ngIf="getInfo?.AppoitmentDetails?.status =='CLAIMED'" -->
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <h4>Refund Details :</h4>
        <!-- </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"> -->
            <table class="table">
                <tbody>
                    <tr>
                        <td>Refund Date</td>
                        <td>:</td>
                        <td>{{getInfo?.claimDetails?.claimDate}}</td>
                    </tr>
                    <tr>
                        <td>Refund Status</td>
                        <td>:</td>
                        <td>{{getInfo?.claimDetails?.claimStatus}}</td>
                    </tr>
                    <tr>
                        <td>Refund Reason</td>
                        <td>:</td>
                        <td>{{getInfo?.claimDetails?.claimReason}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</div>

<div class="container buttons">
  
    <button type="button" class="bb" (click)="modalOpen(cancel)"  *ngIf="getInfo?.AppoitmentDetails?.status =='REJECTED'||getInfo?.AppoitmentDetails?.status =='CANCELED'">Refund</button>
    <button type="button" class="bb2" routerLink="/myappoinment">Go Back</button>
</div>



<ng-template #cancel>
    <!-- <div class="modal-container"> -->
    <!-- Modal Header -->
    <div class="modal-header">
      <h4 class="modal-title">Cancel</h4>
      <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i class="bi bi-x-circle"></i></button>
    </div>
    <!-- Modal body -->
    <div class="modal-body">
      <p class="text-center">Do you want to claim amount from this appointment?</p>
      <textarea class="center-block" name="w3review" rows="4" cols="29" [(ngModel)]="reason_text" #reason='ngModel'
        placeholder="write a reason" required>
          </textarea>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
      <button type="button" class="btn btn-success" (click)="reqClaim(reason.value)">OK</button>
    </div>
    <!-- </div> -->
  </ng-template>


  <ng-template #msg>
    <!-- Modal Header -->
    <div class="modal-header">
      <h4 class="modal-title">Message</h4>
      <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i class="bi bi-x-circle"></i></button>
    </div>
    <!-- Modal body -->
    <div class="modal-body">
      <p class="text-center">{{modalService.config.initialState.message}}</p>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
      <button type="button" class="bb" (click)="modalClose()">OK</button>
    </div>
  </ng-template>


